<div class="knowledge-base-container">
  <!-- Floating Button -->
  <button 
    class="knowledge-base-button" 
    (click)="toggleWidget()"
    [@slideIn]="buttonState"
    [@rotate]="isWidgetOpen ? 'open' : 'closed'"
    [class.active]="isWidgetOpen"
    aria-label="Open Knowledge Base">
    <span class="button-icon">{{ isWidgetOpen ? '✕' : '📚' }}</span>
    <!-- <span class="button-text" *ngIf="!isWidgetOpen">Knowledge Base</span> -->
  </button>

  <!-- Knowledge Base Widget Popup -->
  <div class="knowledge-base-widget-wrapper" *ngIf="isWidgetOpen">
    <app-knowledge-base-widget (widgetClosed)="widgetClosed()"></app-knowledge-base-widget>
  </div>
</div>

